import * as mruTableIdList from './mruTableIdList';
import {
    tryUpdateAlwaysInCacheTableViews,
    initializeAlwaysInCacheTableViews,
} from './alwaysInCacheTableViews';
import { TableQueryType, TableView } from 'owa-mail-list-store';

export function updateTablesInCache(
    tableView: TableView,
    shouldAddToFront: boolean = true
): number | undefined {
    if (tableView.tableQuery.type == TableQueryType.Search) {
        throw new Error('updateTablesInCache should never be called for Search table');
    }

    if (tryUpdateAlwaysInCacheTableViews(tableView)) {
        return 0;
    } else {
        return mruTableIdList.update(tableView, shouldAddToFront);
    }
}

export function initializeTablesInCache() {
    initializeAlwaysInCacheTableViews();
}

export function canAddToMruTableIdList(): boolean {
    return mruTableIdList.canAddToList();
}

// VSO-18425 - refactor the table caching code as per the new design.
// This function should be just remove after the code refactoring
export function removeFromMruTableIdList(tableView: TableView) {
    mruTableIdList.remove(tableView);
}
